<template>
  <div>
    <div
      v-if="isLoading || isCompetitorsFetching"
      class="tw:h-[425px] tw:bg-gray-300 tw:animate-pulse tw:rounded-lg"
    ></div>
    <div v-else-if="isError" class="tw:h-[425px]"></div>

    <div v-else>
      <CompetitorsComparisonTable
        :columns="columns"
        :timeFrame="timeFrame"
        :tableData="timeFrameTrends"
        :isWaitingMode="isWaitingMode"
      />
    </div>
  </div>
</template>

<script setup>
import CompetitorsComparisonTable from '@/components/visitorsProfile/common/CompetitorsComparisonTable.vue'
import { useCompetitors } from '@/components/rateInsights/queries'
import { selectedAccommodationId } from '@/layouts/queries'

defineProps({
  timeFrame: {
    type: String,
    required: true,
    default: '30',
  },
  isLoading: Boolean,
  isError: Boolean,
  timeFrameTrends: Object,
  isWaitingMode: Boolean,
})

const { isCompetitorsFetching } = useCompetitors(selectedAccommodationId)

const columns = {
  weekend: 'vp_time_graph_weekends',
  week: 'vp_time_grap_weekdays',
  longTrip: 'vp_time_graph_extended',
  other: 'vp_time_graph_other',
}
</script>
